import { Injectable } from '@angular/core';
import { EmailApi } from '../../../../../generated/internalApi/api/EmailApi';
import { SessionService } from '../session/shared/session/session-service/session.service';
import { LDCommonWebApiResponseApiResponse } from '../../../../../generated/internalApi/model/models';
import { Observable, throwError } from 'rxjs';

@Injectable()
export class EmailService {
  constructor(
    private emailApi: EmailApi,
    private sessionService: SessionService) {}

  resendVerification(): Observable<LDCommonWebApiResponseApiResponse> {
    const authorizationString = this.sessionService.data.authData.token;

    return this.emailApi.emailResendVerification(authorizationString)
      .catch(err => throwError(err));
  };

  verifyEmail(verifyGuid): Observable<LDCommonWebApiResponseApiResponse> {
    const authorizationString = this.sessionService.data.authData.token;

    return this.emailApi.emailVerifyEmailAddress(verifyGuid, authorizationString);
  }

  openNewEmailMessage({
    to = '',
    from = '',
    subject = '',
    body = ''}): void {

    let href = `mailto:${ encodeURIComponent(to) }` +
               `?from=${ encodeURIComponent(from) }` +
               `&subject=${ encodeURIComponent(subject) }` +
               `&body=${ encodeURIComponent(body) }`;

    window.location.href = href;
  }

  // TODO: Implement function below for email-prompt component
  // sendHelpEmail(): Observable<LDCommonWebApiResponseApiResponse> {
  //   const authorizationString = this.sessionService.data.authData.token;
  //
  //   return this.emailApi.sendHelpEmail();
  // }
}
